import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";

// "Mosaico": una tarjeta por aspecto activo con el % de reducción media en
// grande y un chip por objetivo. Puerto de renderMosaico() del mockup de
// referencia.
export function MosaicVisual({ groups, baseYear, horizonEnd, siteName }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  if (!groups.length) return null;

  return (
    <div style={{ maxWidth: 820, margin: "6px auto 26px", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))", gap: 14 }}>
      {groups.map(({ aspect, objetivos, avgReduction }) => {
        const color = ASPECT_COLOR[aspect] || "#5E89B4";
        return (
          <div key={aspect} style={{ background: mixHex(color, 0.9), borderLeft: `5px solid ${color}`, borderRadius: 12, padding: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <span style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 13, letterSpacing: 1.5, color }}>{t(aspect).toUpperCase()}</span>
              <span style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 30, color }}>−{avgReduction.toFixed(1).replace(".", ",")}%</span>
            </div>
            <div style={{ marginTop: 10 }}>
              {objetivos.map((o) => (
                <span key={o._id} style={{ display: "inline-block", background: "#fff", border: `1px solid ${mixHex(color, 0.55)}`, borderRadius: 14, padding: "4px 11px", fontSize: 11, color: "#1A3562", margin: "0 5px 6px 0" }}>
                  {o.source} −{o.reductionTons}% · {o.year}
                </span>
              ))}
            </div>
          </div>
        );
      })}
      <div style={{ gridColumn: "1/-1", background: "#1A3562", borderRadius: 12, padding: 13, textAlign: "center", color: "#fff", fontFamily: "'Sora',sans-serif", fontWeight: 700, letterSpacing: 2, fontSize: 13 }}>
        {t("pd_wheel_plan_label")} {baseYear}–{horizonEnd} · {(siteName || "").toUpperCase()}
      </div>
    </div>
  );
}
